import {post} from '@/utils/request';
import {flowserver} from '@/utils/baseUrl';

export async function list(params) {
    return post(flowserver+'/api/i18n/list', params, true);
}
export async function save(params) {
    return post(flowserver+'/api/i18n/save', params, true);
}
export async function detail(params) {
    return post(flowserver+'/api/i18n/detail', params, true);
}
export async function modulelist(params) {
    return post(flowserver+'/api/i18n/modulelist', params, true);
}

